// All over the file changes has been done by Dev srini on 07/08/24

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { withStyles } from '@material-ui/core/styles'
import { Checkbox, FormControlLabel, Button } from '@material-ui/core'
import { MenuItem, TextField, Grid, FormControl, InputLabel, Select } from '@mui/material' //dev-trupti on 26-12-2024

import styles from './TicketStyles'

const DateFields = ({
    handleAdd,
    classes, fDate, tDate, type, handleType, handleTdate, handleFdate 
    // checkboxToggle, handlecheckboxChange, status, setStatus,hide, setHide //dev-trupti on 24-12-2024
}) => {

  console.log("field")
    const textFieldStyles = {
        marginLeft:'10px !important',
        width:'150px !important',
        '& .MuiInputBase-root': {
                            backgroundColor: '#131E2E !important',
                            color: 'white !important', 
                            fontFamily: 'cardiuma-regular', 
                            fontSize:'15px'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '131E2E !important',
                        },
                        '& .MuiInputLabel-root': {
                            color: 'white !important',
                            fontFamily: 'cardiuma-regular',
                            fontSize: '14px', 
                        },
                        '& .MuiInputBase-input': {
                            color: 'white !important',
                        },
    }


    return (
        <div style={{ margin: '2% 0 1% 0%' }}>
            <form className={classes.kycFormDateField}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <span >
                        <DatePicker
                            label="From"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={fDate}
                            onChange={(newValue) => { handleFdate(newValue) }}
                        />
                    </span>
                    <span 
                    className={classes.datePickerWrapper}
                    >
                        <DatePicker
                            label="To"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={tDate}
                            onChange={(newValue) => { handleTdate(newValue) }}
                        />
                    </span>
                            <span>
                        <Grid style={{ marginLeft: "10px", borderRadius: "5px" }}>
                            <FormControl size="small" style={{ width: "100%" }}>
                                <InputLabel className={classes.inputColor1} id="demo-select-small-label">
                                    Type
                                </InputLabel>
                                <Select
                                    className={classes.select1}
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={type}
                                    label="Select"
                                    onChange={(newValue) => { handleType(newValue) }}
                                    displayEmpty
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                top: '50px'
                                            },
                                        },
                                    }}
                                    sx={{
                                        height: '40px',
                                        ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                                            color: "#131E2E !important"
                                        },
                                        ".css-bpeome-MuiSvgIcon-root-MuiSelect-icon": {
                                            color: "#131E2E !important"
                                        }
                                    }}
                                >
                                    <MenuItem className={classes.intSelText1} value="Support">
                                       Support
                                    </MenuItem>
                                    <MenuItem className={classes.intSelText1} value="Broking Partner">
                                        Broking Partner
                                    </MenuItem>

                                    {/* <MenuItem className={classes.intSelText} value="Zero brokerage">
                                        Zero Brokerage
                                    </MenuItem>
                                    <MenuItem className={classes.intSelText} value="Zero brokerage Year">
                                        Zero Brokerage Year
                                    </MenuItem> */}
                                </Select>
                            </FormControl>
                        </Grid>
                            </span>

                             
                          
                   

                    
                </LocalizationProvider>
            </form>

            
        </div>
    )
}

export default withStyles(styles)(DateFields)
